import React, {useEffect, useState} from 'react'
import {DESIGN_KEY_PREFIX} from "../../constants/design.constant";
import _ from 'lodash';

const ShowDesignVariantDetail = ({designVariantDetail, hideName}) => {
    const [variantIndex, setVariantIndex] = useState(null);

    useEffect(() => {
        if (designVariantDetail) {
            setVariantIndex(_.parseInt(_.replace(designVariantDetail.key, DESIGN_KEY_PREFIX.VARIANT + '-', '')))
        }
    }, [designVariantDetail]);

    return (
        <>
            <div className="text-xl font-bold text-purple-700 bg-purple-100 px-2 border border-purple-500 rounded">
                <div>
                    #{variantIndex}
                </div>
            </div>
            {!hideName &&
                <div className="text-xl ml-2">
                    {designVariantDetail?.name}
                </div>
            }
        </>
    )
}

export default ShowDesignVariantDetail
